import React, { useEffect, useState } from "react";
import NestedInput from "./NestedInput/NestedInput";
import { ApiMessage, TContactForm } from "Utilities/Types";

// Hooks
import { SubmitHandler, useForm, FormProvider } from "react-hook-form";
import usePost from "Hooks/usePost";
import ReactGA from "react-ga4";

// Styles
import "./ContactForm.scss";
import { enqueueSnackbar, VariantType } from "notistack";
import { trackEvent } from "Services/Analytics/trackEvent";

const ContactForm = () => {
  const {
    data,
    status,
    postData: sendForm,
    error,
  } = usePost<TContactForm | ApiMessage>("api/forms");
  const [sending, setSending] = useState(false);

  const handleSnackbar = (variant: VariantType, message: string) => () => {
    enqueueSnackbar(message, { variant, autoHideDuration: 6000 });
  };

  const methods = useForm<TContactForm>({
    mode: "onBlur",
    defaultValues: {
      message: "",
      name: "",
      email: "",
      phone: undefined,
      country: "Argentina",
      position: "",
      company: "",
    },
  });

  const onSubmit: SubmitHandler<TContactForm> = async (dataForm) => {
    setSending(true);
    ReactGA.event({
      category: "Button",
      action: "contact-form",
    });
    const { message, name, email, phone, country, position, company } =
      dataForm;
    const contactForm: TContactForm = {
      message,
      name,
      email,
      phone: phone,
      country,
      position,
      company,
    };
    trackEvent("contact_form_button");
    try {
      await sendForm(contactForm);
    } catch (err) {
      console.error("Error sending contact form: ", err);
    }
  };

  useEffect(() => {
    if (data && status === 201) {
      handleSnackbar("success", "Tu mensaje se envió correctamente.")();
      methods.reset();
      setSending(false);
    } else if (error && status !== 201) {
      handleSnackbar("error", "Ocurrió un error al enviar tu mensaje.")();
      setSending(false);
    }
  }, [data, error, status, methods]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="form">
        <NestedInput sending={sending} />
      </form>
    </FormProvider>
  );
};
export default ContactForm;
